"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M31.1426 1.18277L40.6538 20.071L31.1426 38.9593L21.6313 20.071L31.1426 1.18277Z",
      stroke: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      opacity: "0.2",
      d: "M20.1426 1.18277L29.6538 20.071L20.1426 38.9593L10.6313 20.071L20.1426 1.18277Z",
      stroke: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      opacity: "0.2",
      d: "M31.0001 0.500056L11.0001 0.500055L0.928901 20.0712L10.9999 39.5L30.9999 39.5",
      stroke: "currentColor"
    })]
  });
};

exports.default = Icon;